<template>
    <div class="flex justify-between items-center">
        <label class="text-sm block">
            <span class="font-normal text-custom-gray-500">
                <slot />
            </span>
            <template v-if="optional">
                <span class="text-slate-400 ml-1">({{ $t('optional') }})</span>
            </template>
        </label>

        <template v-if="limit">
            <div class="text-gray text-sm">{{ char_counter }}/{{ limit }}</div>
        </template>
    </div>
</template>

<script setup>
defineProps({
    optional: {
        type: Boolean,
        default: false,
    },
    limit: {
        type: Number,
        default: null,
    },
})
</script>
